import { render } from "./Navigation_list.vue?vue&type=template&id=1d08d2dc&scoped=true"
import script from "./Navigation_list.vue?vue&type=script&lang=js"
export * from "./Navigation_list.vue?vue&type=script&lang=js"

import "./Navigation_list.vue?vue&type=style&index=0&id=1d08d2dc&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\vue\\portfolio-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d08d2dc"]])

export default __exports__